import { render, staticRenderFns } from "./IconPending.vue?vue&type=template&id=16f6d41c&"
import script from "./IconPending.vue?vue&type=script&lang=ts&"
export * from "./IconPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports